module.exports = __webpack_public_path__ + "assets/icon-x.6531a56a.svg";